export default __webpack_public_path__ + "static/media/guess-friends-1.0de2356d.jpg";